import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

function Join() {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'join_page_view', {
        event_category: 'engagement',
        event_label: 'Join Page Loaded'
      });
    }

    if (window.fbq) {
      window.fbq('trackCustom', 'JoinPageView');
    }
  }, []);

  const handleJoinClick = () => {
    if (window.fbq) {
      window.fbq('trackCustom', 'JoinClick');
    }
    if (window.gtag) {
      window.gtag('event', 'join_click', {
        event_category: 'engagement',
        event_label: 'Join Page CTA',
      });
    }
    navigate('/register');
  };

  return (
    <div className="pt-16 flex items-center justify-center px-4">
      <motion.div
        className="text-center max-w-xl py-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="text-4xl font-bold mb-4">
          <span role="img" aria-label="car">🚗</span> Know What Every Car Is <span className="text-teal-700 italic">Really</span> Worth
        </div>
        <p className="text-lg text-gray-700 mb-6">
          Meshum helps you compare real sold prices, track market trends, and spot overpriced listings before you buy.
        </p>
        <ul className="text-left text-gray-800 list-disc list-inside space-y-1 mb-6">
          <li>✅ View sold car comps with VIN match</li>
          <li>✅ Save your favorite listings</li>
          <li>✅ Get alerts for future price drops</li>
          <li>✅ Understand dealer pricing trends</li>
          <li>✅ It’s 100% free — no spam, ever</li>
        </ul>
        <button
          onClick={handleJoinClick}
          className="inline-block bg-teal-700 hover:bg-teal-800 text-white font-semibold py-3 px-6 rounded transition duration-300"
        >
          Create Free Account
        </button>
        <p className="text-sm text-gray-600 mt-4">
          Already have an account?{' '}
          <Link to="/login" className="text-teal-600 underline">
            Log in here
          </Link>
        </p>
      </motion.div>
    </div>
  );
}

export default Join;
